// MapController.jsx
import { useMap } from "@vis.gl/react-google-maps";
import { useEffect } from "react";

export default function MapController({ lat, lng }) {
  const map = useMap("main-map");

  useEffect(() => {
    if (map && lat && lng) {
      map.panTo({ lat, lng });
    }
  }, [map, lat, lng]);

  return null; // no UI
}
